import React, { useState, useEffect } from 'react';
import { config } from "./Const.js";
import 'reactjs-popup/dist/index.css';
import { TextField, Autocomplete, Chip, Box } from '@mui/material';

import { executeFetch } from './Util.js';

function TagSelector(props) {
    const value = props.selected ?? [];
    const notifyTagValuesChange = props.onTagValuesChange || (() => { });
    const notifyMainTagChange = props.onMainTagChange || (() => { });
    const mainTag = props.mainTag;
    const [availableTagList, setAvailableTagList] = useState([]);

    const generateAllTagUrl = () => {
        return config.SERVER_URL + "/api/v1/admin/entityData/allTags";
    };

    const fetchAvailableTagList = () => {
        const url = generateAllTagUrl();

        const responseDataHandler = (result) => {
            setAvailableTagList(result);
        };

        executeFetch(url, "get", null, null, null, responseDataHandler);
    };

    useEffect(() => {
        fetchAvailableTagList();
        // eslint-disable-next-line
    }, []);

    // --- NEW: compare by idMapping.WIKIDATA if present; otherwise by label ---
    const getWikidataId = (tag) => tag?.idMapping?.WIKIDATA ?? null;

    const normalizeLabel = (tag) => (tag?.label ?? '').trim();

    const isSameTag = (a, b) => {
        if (!a || !b) return false;

        const aWd = getWikidataId(a);
        const bWd = getWikidataId(b);

        // If both have Wikidata IDs, compare those
        if (aWd && bWd) return aWd === bWd;

        // Otherwise fall back to label comparison
        return normalizeLabel(a) === normalizeLabel(b);
    };

    const handleChipClick = (option) => {
        notifyMainTagChange(option);
    };

    return (
        <Box>
            <Autocomplete
                multiple
                id="tags-filled"
                options={availableTagList}
                getOptionLabel={(option) => option?.label ?? ''}

                // NOTE: in MUI v5+ this is the preferred prop (instead of getOptionSelected)
                isOptionEqualToValue={(option, v) => isSameTag(option, v)}

                value={value}
                onChange={(event, newValue) => {
                    const modifiedValues = newValue.map((option) =>
                        // If the user enters text in freeSolo mode, convert it into your tag object shape
                        typeof option === 'string' ? { label: option } : option
                    );

                    notifyTagValuesChange(modifiedValues);
                }}
                freeSolo
                renderTags={(tagValue, getTagProps) =>
                    tagValue.map((option, index) => {
                        const isMain = isSameTag(mainTag, option);

                        return (
                            <Chip
                                variant="outlined"
                                sx={{
                                    backgroundColor: isMain ? '#1976d2' : 'white',
                                    color: isMain ? 'white' : 'black',
                                }}
                                onClick={() => handleChipClick(option)}
                                label={option?.label ?? ''}
                                {...getTagProps({ index })}
                            />
                        );
                    })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Tags"
                    />
                )}
            />
        </Box>
    );
}

export default TagSelector;
